import axios from 'axios';

/**
 * Response of POST /api/payments/bridgerpay/initiate-payment.
 *
 * Mirrors the backend BridgerPayInitResponseDTO. When the virtual wallet fully
 * covers the amount, the backend settles the payment directly and returns
 * `{ callbackId }` (HTTP 201) instead of a cashier session — in that case
 * `cashierToken`/`cashierKey` are absent and the caller must redirect to the
 * payment status page using `callbackId`.
 */
export interface BridgerPayInitResponse {
  externalId?: string;
  cashierToken?: string;
  cashierKey?: string;
  finalAmount?: number;
  birthDate?: string;
  /** Present only when the deposit was fully paid with the virtual wallet. */
  callbackId?: string;
}

/**
 * Initiates a BridgerPay credit-card / Apple Pay deposit and returns the cashier
 * widget session details rendered by {@link BridgerPayWidget}.
 *
 * The endpoint is open (no auth) like the previous Corefy initiate, so guest
 * checkout keeps working. The client IP is added by the reverse proxy
 * (`X-Forwarded-For`); the browser cannot set it.
 */
export const initiateBridgerPayment = async (
  paymentData: unknown,
): Promise<BridgerPayInitResponse> => {
  const response = await axios.post<BridgerPayInitResponse>(
    `https://${process.env.REACT_APP_API_URL}/api/payments/bridgerpay/initiate-payment`,
    paymentData,
  );
  return response.data;
};
